/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubsidiaryCommandDto
 */
export interface UpdateSubsidiaryCommandDto {
    /**
     * Name of the subsidiary
     * @type {string}
     * @memberof UpdateSubsidiaryCommandDto
     */
    companyName: string;
    /**
     * SIRET number of the subsidiary
     * @type {string}
     * @memberof UpdateSubsidiaryCommandDto
     */
    registrationNumber: string;
    /**
     * Revenue of the last closed fiscal year, in euros
     * @type {number}
     * @memberof UpdateSubsidiaryCommandDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof UpdateSubsidiaryCommandDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof UpdateSubsidiaryCommandDto
     */
    fiscalYearEnd: string;
}

/**
 * Check if a given object implements the UpdateSubsidiaryCommandDto interface.
 */
export function instanceOfUpdateSubsidiaryCommandDto(value: object): value is UpdateSubsidiaryCommandDto {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function UpdateSubsidiaryCommandDtoFromJSON(json: any): UpdateSubsidiaryCommandDto {
    return UpdateSubsidiaryCommandDtoFromJSONTyped(json, false);
}

export function UpdateSubsidiaryCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubsidiaryCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
    };
}

export function UpdateSubsidiaryCommandDtoToJSON(json: any): UpdateSubsidiaryCommandDto {
    return UpdateSubsidiaryCommandDtoToJSONTyped(json, false);
}

export function UpdateSubsidiaryCommandDtoToJSONTyped(value?: UpdateSubsidiaryCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
    };
}

